const nb = {
  kicker: "Testversjon",
  title: "Spill Trollfossjakten nå med Expo Go.",
  lead: "Vi tester appen og ferdigstiller partneravtaler. Hele appen lanseres i App Store og Google Play innen 1. februar 2027. Fram til da kan du spille testversjonen gratis.",
  notice: "Testversjon — ting kan endre seg før lansering",
  step1: "Installer Expo Go",
  step1Body: "Expo Go er en gratis app som kjører testversjonen vår. Last den ned fra appbutikken din.",
  step2: "Skann koden",
  step2Body: "iPhone: skann koden med Kamera-appen. Android: åpne Expo Go og trykk «Scan QR code».",
  step3: "Eller åpne lenken på telefonen",
  step3Body: "Har du allerede Expo Go? Trykk på knappen på telefonen for å åpne testversjonen direkte.",
  open: "Åpne i Expo Go",
  copyLink: "Kopier lenke",
  copied: "Lenken er kopiert",
  qrAlt: "QR-kode for testappen til Trollfossjakten",
  dlTitle: "Last ned testversjonen",
  dlExpo: "1 · Hent Expo Go (gratis)",
  dlOpen: "2 · Åpne testappen vår",
  dlLink: "Direkte lenke",
  qrCaption: "Skann for å åpne testversjonen",
};

export default nb;
